export default theme => ({
  confirm: {
    marginTop: 10,
    marginBottom: 20,
  },
  success: {
    backgroundColor: theme.palette.success.dark,
  },
  error: {
    backgroundColor: theme.palette.secondary.main,
  },
  warning: {
    backgroundColor: theme.palette.warning.dark,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: "flex",
    alignItems: "center",
  },
  root: {
    padding: "6px 6px",
  },
  action: {
    paddingLeft: 0,
    marginRight: 0,
  },
});
